/* =========================================================
   BlindTaste Quiz - logic
   Single-file state machine + dynamic rendering.
   ========================================================= */

(function () {
  "use strict";

  /* ---------- Data: questions ---------- */

  const PROFILES_KEYS = ["curiosoPrudente", "esploratore", "narratore", "degustatore"];

  // tie-break priority when scores collide AND Q14 does not disambiguate.
  // Esploratore first → it's the most conversion-friendly profile for BlindTaste.
  const TIE_BREAK_FALLBACK = ["esploratore", "degustatore", "narratore", "curiosoPrudente"];

  const QUESTIONS = {
    q3: {
      type: "binary",
      eyebrow: "La tua scelta",
      text: "Quando scegli un vino, di solito sei più tipo…",
      options: [
        { id: "sicuro",  label: "Vado sul sicuro", sub: "Scelgo qualcosa che conosco già." },
        { id: "curioso", label: "Mi lascio incuriosire", sub: "Se non lo conosco, ancora meglio." }
      ]
    },
    q4: {
      type: "single",
      eyebrow: "Alla cieca",
      text: "Quanto ti piace l'idea di assaggiare un vino senza sapere subito cos'è?",
      options: [
        { id: "incuriosisce",   label: "Mi incuriosisce parecchio" },
        { id: "indizio",        label: "Mi diverte, ma vorrei qualche indizio" },
        { id: "crisi",          label: "Mi mette un po' in crisi" },
        { id: "sapere-subito",  label: "Preferisco sapere subito cosa bevo" }
      ]
    },
    q5: {
      type: "single",
      eyebrow: "Davanti allo scaffale",
      text: "Davanti a uno scaffale pieno di vini, cosa succede di solito?",
      options: [
        { id: "etichetta",    label: "Scelgo quello con l'etichetta più bella" },
        { id: "conosciuta",   label: "Prendo una bottiglia che conosco già" },
        { id: "strano",       label: "Cerco qualcosa di strano che non ho mai provato" },
        { id: "bloccato",     label: "Rimango bloccato e scelgo quasi a caso" },
        { id: "consiglio",    label: "Chiedo consiglio a qualcuno" }
      ]
    },
    q6: {
      type: "binary",
      eyebrow: "Per te il vino è…",
      text: "Per te il vino è più…",
      options: [
        { id: "piacere",  label: "Piacere", sub: "Lo bevo per godermi il momento." },
        { id: "scoperta", label: "Scoperta", sub: "Mi piace capire cosa c'è dentro e dietro." }
      ]
    },
    q7: {
      type: "single",
      eyebrow: "Manifesto",
      text: "Quale frase ti rappresenta meglio?",
      options: [
        { id: "bere-bene",   label: "Voglio bere bene, senza fare un corso da sommelier" },
        { id: "introvabili", label: "Mi piace scoprire vini che non trovo ovunque" },
        { id: "condivisi",   label: "Il vino è più bello quando lo condivido" },
        { id: "senza-influenza", label: "Mi piace capire se un vino mi piace davvero, senza farmi influenzare" },
        { id: "imparare",    label: "Vorrei imparare, ma senza troppi paroloni" }
      ]
    },
    q8: {
      type: "multi",
      maxSelections: 2,
      eyebrow: "Sensazioni",
      text: "Quando assaggi un vino nuovo, cosa ti fa dire \"ok, questo mi piace\"?",
      hint: "Puoi sceglierne fino a 2.",
      options: [
        { id: "facile",      label: "È facile da bere" },
        { id: "profumo",     label: "Ha un profumo che mi colpisce" },
        { id: "fresco",      label: "È fresco e piacevole" },
        { id: "morbido",     label: "È morbido e avvolgente" },
        { id: "carattere",   label: "Ha carattere" },
        { id: "raccontarlo", label: "Mi fa venire voglia di raccontarlo" },
        { id: "abbinamento", label: "Sta benissimo con quello che sto mangiando" }
      ]
    },
    q9: {
      type: "single",
      eyebrow: "Sii sincero",
      text: "Hai mai scelto un vino solo perché aveva una bella etichetta?",
      options: [
        { id: "sì-rifarei",   label: "Sì, e probabilmente lo rifarei" },
        { id: "sì-finta",     label: "Sì, ma poi ho fatto finta fosse una scelta tecnica" },
        { id: "no-razionale", label: "No, io sono più razionale" },
        { id: "non-ricordo",  label: "Non ricordo, ma potrebbe essere successo" }
      ]
    },
    q10: {
      type: "binary",
      eyebrow: "Storia",
      text: "Ti interessa scoprire la storia dietro una bottiglia?",
      options: [
        { id: "sì-storia", label: "Sì", sub: "Mi piace sapere chi l'ha fatta e da dove arriva." },
        { id: "no-buona",  label: "Non troppo", sub: "Mi basta che sia buona." }
      ]
    },
    q11: {
      type: "single",
      eyebrow: "Con chi",
      text: "Con chi berresti più volentieri una box BlindTaste?",
      options: [
        { id: "solo",     label: "Da solo, con calma" },
        { id: "coppia",   label: "In coppia" },
        { id: "amici",    label: "Con amici" },
        { id: "cena",     label: "Durante una cena" },
        { id: "regalo",   label: "Come regalo per qualcuno" },
        { id: "serata",   label: "Per una serata diversa dal solito" }
      ]
    },
    q12: {
      type: "binary",
      eyebrow: "Degustazione",
      text: "Preferisci una degustazione più guidata o più libera?",
      options: [
        { id: "guidata", label: "Guidata", sub: "Mi piace avere spiegazioni, contenuti e piccoli aiuti." },
        { id: "libera",  label: "Libera",  sub: "Preferisco assaggiare prima senza troppe indicazioni." }
      ]
    },
    q13: {
      type: "single",
      eyebrow: "Sfida",
      text: "Quanto ti piacerebbe metterti alla prova?",
      options: [
        { id: "molto",     label: "Molto, mi diverte indovinare" },
        { id: "abbastanza", label: "Abbastanza, ma senza prenderla troppo sul serio" },
        { id: "poco",      label: "Poco, voglio solo godermi il vino" },
        { id: "compagnia", label: "Dipende dalla compagnia" }
      ]
    },
    q14: {
      type: "single",
      eyebrow: "Manifesto",
      text: "Se ti dicessimo che potresti amare un vino che normalmente non avresti mai comprato, tu…",
      options: [
        { id: "subito",     label: "Lo proverei subito" },
        { id: "dubbio",     label: "Lo proverei, ma con qualche dubbio" },
        { id: "dipende",    label: "Dipende dal vino" },
        { id: "certezze",   label: "Probabilmente resterei sulle mie certezze" }
      ]
    },
    q15: {
      type: "single",
      eyebrow: "Sorpresa",
      text: "Che tipo di sorpresa ti piacerebbe ricevere?",
      options: [
        { id: "facile-non-banale", label: "Una bottiglia facile, ma non banale" },
        { id: "territoriale",      label: "Un vino territoriale poco conosciuto" },
        { id: "spiazzi",           label: "Qualcosa che mi spiazzi un po'" },
        { id: "condividere",       label: "Una bottiglia perfetta da condividere" },
        { id: "storia",            label: "Un vino con una bella storia dietro" },
        { id: "sorprendimi",       label: "Non lo so: sorprendimi" }
      ]
    },
    q16: {
      type: "single",
      eyebrow: "Approfondimento",
      text: "Quanto vuoi approfondire dopo l'assaggio?",
      options: [
        { id: "essenziali",   label: "Solo le informazioni essenziali" },
        { id: "semplice",     label: "Una spiegazione semplice e chiara" },
        { id: "produttore",   label: "Storia del produttore e territorio" },
        { id: "appassionato", label: "Scheda più completa da appassionato" },
        { id: "video",        label: "Video o contenuti guidati" }
      ]
    }
  };

  /* ---------- Versions ---------- */

  // 8-question quick version: keeps the conversion-critical signals
  // and Q14 (the manifesto / tie-breaker).
  const QUICK_KEYS = ["q3", "q4", "q6", "q7", "q10", "q13", "q14", "q15"];
  const FULL_KEYS  = ["q3", "q4", "q5", "q6", "q7", "q8", "q9", "q10", "q11", "q12", "q13", "q14", "q15", "q16"];

  /* ---------- Scoring map ---------- */
  // Each entry adds points to one or more profiles when the option is selected.
  // Extrapolated from the partial table in the brief - to be reviewed.

  const SCORING = {
    q3: {
      sicuro:  { curiosoPrudente: 2 },
      curioso: { esploratore: 2 }
    },
    q4: {
      incuriosisce:   { esploratore: 2, degustatore: 1 },
      indizio:        { curiosoPrudente: 1, narratore: 1 },
      crisi:          { curiosoPrudente: 2 },
      "sapere-subito": { curiosoPrudente: 2 }
    },
    q5: {
      etichetta:    { narratore: 1 },
      conosciuta:   { curiosoPrudente: 2 },
      strano:       { esploratore: 2 },
      bloccato:     { curiosoPrudente: 1, narratore: 1 },
      consiglio:    { curiosoPrudente: 1, narratore: 1 }
    },
    q6: {
      piacere:  { curiosoPrudente: 1, narratore: 1 },
      scoperta: { esploratore: 1, degustatore: 1 }
    },
    q7: {
      "bere-bene":       { curiosoPrudente: 2 },
      introvabili:       { esploratore: 2 },
      condivisi:         { narratore: 2 },
      "senza-influenza": { degustatore: 2 },
      imparare:          { curiosoPrudente: 1, narratore: 1 }
    },
    q8: {
      facile:      { curiosoPrudente: 1 },
      profumo:     { degustatore: 1, narratore: 1 },
      fresco:      { curiosoPrudente: 1 },
      morbido:     { curiosoPrudente: 1 },
      carattere:   { esploratore: 1, degustatore: 1 },
      raccontarlo: { narratore: 2 },
      abbinamento: { narratore: 1, curiosoPrudente: 1 }
    },
    q9: {
      "sì-rifarei":   { narratore: 1, esploratore: 1 },
      "sì-finta":     { narratore: 1 },
      "no-razionale": { degustatore: 2 },
      "non-ricordo":  { curiosoPrudente: 1 }
    },
    q10: {
      "sì-storia": { narratore: 2 },
      "no-buona":  { curiosoPrudente: 1, esploratore: 1 }
    },
    q11: {
      solo:   { degustatore: 2 },
      coppia: { narratore: 1 },
      amici:  { narratore: 1, esploratore: 1 },
      cena:   { narratore: 2 },
      regalo: { curiosoPrudente: 1, narratore: 1 },
      serata: { esploratore: 2 }
    },
    q12: {
      guidata: { curiosoPrudente: 1, narratore: 1 },
      libera:  { esploratore: 1, degustatore: 1 }
    },
    q13: {
      molto:      { degustatore: 2 },
      abbastanza: { esploratore: 1, narratore: 1 },
      poco:       { curiosoPrudente: 2 },
      compagnia:  { narratore: 1 }
    },
    q14: {
      subito:   { esploratore: 2 },
      dubbio:   { curiosoPrudente: 1, esploratore: 1 },
      dipende:  { degustatore: 1, narratore: 1 },
      certezze: { curiosoPrudente: 2 }
    },
    q15: {
      "facile-non-banale": { curiosoPrudente: 2 },
      territoriale:        { esploratore: 1, narratore: 1 },
      spiazzi:             { esploratore: 2 },
      condividere:         { narratore: 2 },
      storia:              { narratore: 2 },
      sorprendimi:         { esploratore: 2 }
    },
    q16: {
      essenziali:   { curiosoPrudente: 2 },
      semplice:     { curiosoPrudente: 1, narratore: 1 },
      produttore:   { narratore: 2 },
      appassionato: { degustatore: 2 },
      video:        { degustatore: 1, narratore: 1 }
    }
  };

  // Tie-break priorities driven by Q14 (the "manifesto" question).
  const Q14_TIE_PRIORITY = {
    subito:   ["esploratore", "degustatore", "narratore", "curiosoPrudente"],
    dubbio:   ["esploratore", "curiosoPrudente", "narratore", "degustatore"],
    dipende:  ["degustatore", "narratore", "esploratore", "curiosoPrudente"],
    certezze: ["curiosoPrudente", "narratore", "esploratore", "degustatore"]
  };

  /* ---------- Profile copy ---------- */

  const PROFILES = {
    curiosoPrudente: {
      key: "curiosoPrudente",
      slug: "curioso-prudente",
      name: "Il Curioso Prudente",
      tagline: "Vuoi scoprire, ma con una guida accanto.",
      promise: "Ti aiutiamo a scoprire vini nuovi senza farti sentire fuori posto. Bottiglie facili ma non banali, con piccole spiegazioni che ti accompagnano.",
      includes: [
        "2 vini accessibili e ben scelti",
        "Scheda semplice con le note chiave",
        "QR per spiegazione passo passo"
      ],
      ctaLabel: "Inizia con una box guidata"
    },
    esploratore: {
      key: "esploratore",
      slug: "esploratore",
      name: "L'Esploratore",
      tagline: "Ami la sorpresa, soprattutto quando arriva da dove non te l'aspetti.",
      promise: "Ogni box è una piccola esplorazione oltre l'etichetta. Vini che da solo non avresti scelto - ma che potresti finire per amare.",
      includes: [
        "Vini territoriali poco conosciuti",
        "Degustazione completamente alla cieca",
        "Reveal e mini-storia dopo l'assaggio"
      ],
      ctaLabel: "Scopri la tua prossima box alla cieca"
    },
    narratore: {
      key: "narratore",
      slug: "narratore",
      name: "Il Narratore",
      tagline: "Il vino, per te, è anche la storia che porta dentro.",
      promise: "Ti portiamo dentro la storia della bottiglia, non solo dentro il bicchiere: territori, persone, scelte da bere insieme.",
      includes: [
        "Vini con una storia forte alle spalle",
        "Ritratto del produttore e del territorio",
        "Spunti di racconto per cena"
      ],
      ctaLabel: "Vivi il vino come un racconto"
    },
    degustatore: {
      key: "degustatore",
      slug: "degustatore",
      name: "Il Degustatore",
      tagline: "Vuoi capire davvero quello che hai nel bicchiere.",
      promise: "Assaggi prima, scopri dopo, confronti le tue sensazioni con quelle del produttore. Il modo più onesto per allenare il palato.",
      includes: [
        "Vini di carattere da analizzare",
        "Scheda tecnica completa post-reveal",
        "Confronto guidato con le note del produttore"
      ],
      ctaLabel: "Metti alla prova il tuo palato"
    }
  };

  /* ---------- Tracking ---------- */
  // The client posts to a Supabase Edge Function that validates the payload,
  // rate-limits per IP, and performs the upsert with the service_role key.
  // No Supabase key is exposed in the client - see TRACKING.md.
  //
  // Set TRACKING.endpoint to the deployed function URL, e.g.
  //   https://<project>.supabase.co/functions/v1/quiz-event
  // The function must be deployed with --no-verify-jwt (no auth header needed).

  const TRACKING = {
    endpoint: "https://yvxtmojprfjnglljkieh.supabase.co/functions/v1/quiz-event",
    enabled: true
  };

  function uuidV4() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (c) {
      const r = window.crypto.getRandomValues(new Uint8Array(1))[0];
      return (Number(c) ^ (r & (15 >> (Number(c) / 4)))).toString(16);
    });
  }

  function getQueryParam(name) {
    try { return new URLSearchParams(window.location.search).get(name); }
    catch (_) { return null; }
  }

  // Fires a quiz event. The Edge Function whitelists which fields land in DB
  // and upserts by session_id, so only the columns we send are written.
  function track(event, payload) {
    if (!TRACKING.enabled || !state.sessionId) return;
    const body = Object.assign({ event: event, session_id: state.sessionId }, payload || {});

    try { console.log("[BT track]", event, body); } catch (_) {}

    if (!TRACKING.endpoint) return;

    try {
      fetch(TRACKING.endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        keepalive: true,
        mode: "cors"
      }).catch(function () { /* fire-and-forget */ });
    } catch (_) { /* swallow */ }
  }

  /* ---------- State ---------- */

  const state = {
    screen: "intro", // intro | version | gender | privacy | privacy-declined | question | result | email | email-thanks
    sessionId: null, // generated when the user clicks "Inizia il quiz"
    startedAt: null,
    version: null,   // "quick" | "full"
    gender: null,
    privacy: null,
    answers: {},     // { q3: "curioso", q8: ["profumo","carattere"], ... }
    questionIndex: 0,
    profile: null,
    scores: null,
    email: null
  };

  /* ---------- DOM refs ---------- */

  const stage = document.getElementById("bt-stage");
  const progress = document.getElementById("bt-progress");
  const progressBar = document.getElementById("bt-progress-bar");
  const closeBtn = document.getElementById("bt-close");

  closeBtn.addEventListener("click", function (e) {
    e.preventDefault();
    if (confirm("Vuoi davvero uscire dal quiz? Le risposte verranno perse.")) {
      window.location.href = "/";
    }
  });

  /* ---------- Helpers ---------- */

  function getActiveKeys() {
    return state.version === "quick" ? QUICK_KEYS : FULL_KEYS;
  }

  function setProgress(ratio) {
    if (ratio > 0) progress.classList.add("is-visible");
    else progress.classList.remove("is-visible");
    progressBar.style.width = Math.max(0, Math.min(1, ratio)) * 100 + "%";
  }

  function el(tag, attrs, children) {
    const node = document.createElement(tag);
    if (attrs) {
      for (const k in attrs) {
        if (k === "class") node.className = attrs[k];
        else if (k === "html") node.innerHTML = attrs[k];
        else if (k.startsWith("on") && typeof attrs[k] === "function") {
          node.addEventListener(k.slice(2).toLowerCase(), attrs[k]);
        } else {
          node.setAttribute(k, attrs[k]);
        }
      }
    }
    if (children) {
      (Array.isArray(children) ? children : [children]).forEach(function (c) {
        if (c == null || c === false) return;
        node.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
      });
    }
    return node;
  }

  function clearStage() { stage.innerHTML = ""; }

  function checkIcon() {
    const wrap = el("span", { class: "bt-option__check" });
    wrap.innerHTML = '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6.5L5 9.5L10 3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return wrap;
  }

  function backButton(onClick) {
    return el("button", { class: "bt-screen__back", type: "button", onClick: onClick },
      [
        (function () {
          const s = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          s.setAttribute("viewBox", "0 0 14 14");
          s.setAttribute("aria-hidden", "true");
          s.innerHTML = '<path d="M9 2L4 7L9 12" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/>';
          return s;
        })(),
        "Indietro"
      ]
    );
  }

  /* ---------- Render: screens ---------- */

  function renderIntro() {
    setProgress(0);
    clearStage();
    const screen = el("div", { class: "bt-screen" }, [
      el("p", { class: "bt-screen__eyebrow" }, "Quiz BlindTaste"),
      el("h1", { class: "bt-screen__title" }, "Scopri che tipo di bevitore sei quando nessuna etichetta può influenzarti."),
      el("p", { class: "bt-screen__sub" }, "Qualche domanda leggera per costruire il tuo profilo di degustazione. Nessun tecnicismo, promesso."),
      el("button", {
        class: "bt-cta",
        type: "button",
        onClick: function () { startQuiz(); }
      }, "Inizia il quiz")
    ]);
    stage.appendChild(screen);
  }

  function startQuiz() {
    state.sessionId = uuidV4();
    state.startedAt = new Date().toISOString();
    try { localStorage.setItem("bt:sessionId", state.sessionId); } catch (_) {}

    track("quiz_started", {
      started_at: state.startedAt,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent || null,
      utm_source:   getQueryParam("utm_source"),
      utm_medium:   getQueryParam("utm_medium"),
      utm_campaign: getQueryParam("utm_campaign"),
      utm_content:  getQueryParam("utm_content"),
      utm_term:     getQueryParam("utm_term")
    });

    state.screen = "version";
    render();
  }

  function renderVersion() {
    setProgress(0);
    clearStage();
    const screen = el("div", { class: "bt-screen" }, [
      el("p", { class: "bt-screen__eyebrow" }, "Quanto tempo hai?"),
      el("h2", { class: "bt-screen__title" }, "Scegli la versione che ti va."),
      el("p", { class: "bt-screen__sub" }, "Il risultato è preciso in entrambi i casi. La versione completa rende il profilo più sfumato."),
      el("div", { class: "bt-options" }, [
        el("button", {
          class: "bt-option", type: "button",
          onClick: function () { state.version = "quick"; state.screen = "gender"; render(); }
        }, [
          el("span", null, [
            el("strong", { style: "display:block;font-weight:600;" }, "Versione veloce"),
            el("span", { style: "color:var(--bt-text-mute);font-size:14px;" }, "~2 minuti · 8 domande")
          ]),
          el("span", { style: "color:var(--bt-text-mute);font-size:13px;" }, "→")
        ]),
        el("button", {
          class: "bt-option", type: "button",
          onClick: function () { state.version = "full"; state.screen = "gender"; render(); }
        }, [
          el("span", null, [
            el("strong", { style: "display:block;font-weight:600;" }, "Versione completa"),
            el("span", { style: "color:var(--bt-text-mute);font-size:14px;" }, "~5 minuti · 14 domande · profilo più dettagliato")
          ]),
          el("span", { style: "color:var(--bt-text-mute);font-size:13px;" }, "→")
        ])
      ])
    ]);
    stage.appendChild(screen);
  }

  function renderGender() {
    setProgress(0);
    clearStage();
    const screen = el("div", { class: "bt-screen" }, [
      backButton(function () { state.screen = "version"; render(); }),
      el("p", { class: "bt-screen__eyebrow" }, "Per iniziare"),
      el("h2", { class: "bt-screen__title" }, "Come preferisci identificarti?"),
      el("p", { class: "bt-screen__hint" }, "Solo per segmentazione. Non influenza il tuo profilo vino."),
      el("div", { class: "bt-options" }, [
        ["donna", "Donna"],
        ["uomo", "Uomo"],
        ["preferisco-non-dirlo", "Preferisco non dirlo"]
      ].map(function (pair) {
        return el("button", {
          class: "bt-option", type: "button",
          onClick: function () { state.gender = pair[0]; state.screen = "privacy"; render(); }
        }, [el("span", null, pair[1]), checkIcon()]);
      }))
    ]);
    stage.appendChild(screen);
  }

  function renderPrivacy() {
    setProgress(0);
    clearStage();
    const screen = el("div", { class: "bt-screen" }, [
      backButton(function () { state.screen = "gender"; render(); }),
      el("p", { class: "bt-screen__eyebrow" }, "Privacy"),
      el("h2", { class: "bt-screen__title" }, "Possiamo usare le tue risposte per creare il tuo profilo BlindTaste?"),
      el("p", { class: "bt-screen__sub", html:
        'Le risposte vengono usate per costruire il profilo e personalizzare la box consigliata. ' +
        'Maggiori info nella nostra <a href="https://www.theblindtaste.it/pages/informativa-sulla-privacy" target="_blank" rel="noopener">Informativa sulla privacy</a> ' +
        'e nei <a href="https://www.theblindtaste.it/pages/termini-e-condizioni" target="_blank" rel="noopener">Termini</a>.'
      }),
      el("div", { class: "bt-options" }, [
        el("button", {
          class: "bt-option", type: "button",
          onClick: function () { state.privacy = true; state.screen = "question"; state.questionIndex = 0; render(); }
        }, [el("span", null, "Sì, accetto"), checkIcon()]),
        el("button", {
          class: "bt-option", type: "button",
          onClick: function () { state.privacy = false; state.screen = "privacy-declined"; render(); }
        }, [el("span", null, "No, non accetto"), checkIcon()])
      ])
    ]);
    stage.appendChild(screen);
  }

  function renderPrivacyDeclined() {
    setProgress(0);
    clearStage();
    const screen = el("div", { class: "bt-screen" }, [
      el("p", { class: "bt-screen__eyebrow" }, "Capiamo"),
      el("h2", { class: "bt-screen__title" }, "Senza il tuo consenso non possiamo costruire il tuo profilo."),
      el("p", { class: "bt-screen__sub" }, "Quando vuoi, torna pure qui - il quiz è breve e leggero."),
      el("button", {
        class: "bt-cta", type: "button",
        onClick: function () { state.screen = "privacy"; render(); }
      }, "Torna alla domanda"),
      el("a", { class: "bt-link-btn", href: "/" }, "Torna al sito")
    ]);
    stage.appendChild(screen);
  }

  function renderQuestion() {
    const keys = getActiveKeys();
    const key = keys[state.questionIndex];
    const q = QUESTIONS[key];

    // progress: setup phase is 2 screens (gender/privacy), but we only show
    // progress for the quiz phase itself for a cleaner sense of momentum.
    const ratio = (state.questionIndex + 1) / keys.length;
    setProgress(ratio);

    clearStage();

    const headerBack = state.questionIndex === 0
      ? function () { state.screen = "privacy"; render(); }
      : function () { state.questionIndex -= 1; render(); };

    const screen = el("div", { class: "bt-screen" });
    screen.appendChild(backButton(headerBack));
    screen.appendChild(el("p", { class: "bt-screen__eyebrow" },
      "Domanda " + (state.questionIndex + 1) + " di " + keys.length + " · " + q.eyebrow
    ));
    screen.appendChild(el("h2", { class: "bt-screen__title" }, q.text));
    if (q.hint) screen.appendChild(el("p", { class: "bt-screen__hint" }, q.hint));

    const optionsWrap = el("div", {
      class: "bt-options" + (q.type === "binary" ? " bt-options--cards" : "")
    });

    const existing = state.answers[key];

    q.options.forEach(function (opt) {
      const isSelected = (q.type === "multi")
        ? Array.isArray(existing) && existing.indexOf(opt.id) !== -1
        : existing === opt.id;

      const inner = [];
      const labelBlock = el("span", null);
      labelBlock.appendChild(el("strong", { style: "display:block;font-weight:500;" }, opt.label));
      if (opt.sub) labelBlock.appendChild(el("span", { style: "display:block;color:var(--bt-text-mute);font-size:14px;margin-top:2px;" }, opt.sub));
      inner.push(labelBlock);
      inner.push(checkIcon());

      const node = el("button", {
        class: "bt-option" + (isSelected ? " is-selected" : ""),
        type: "button",
        onClick: function () { handleAnswer(key, q, opt.id); }
      }, inner);

      optionsWrap.appendChild(node);
    });

    screen.appendChild(optionsWrap);

    // for multi-select questions we need a "Continua" CTA
    if (q.type === "multi") {
      const selected = Array.isArray(existing) ? existing : [];
      const cta = el("button", {
        class: "bt-cta", type: "button",
        onClick: function () { advanceQuestion(); }
      }, "Continua");
      if (selected.length === 0) cta.disabled = true;
      screen.appendChild(cta);
    }

    stage.appendChild(screen);
  }

  function handleAnswer(key, q, optionId) {
    if (q.type === "multi") {
      const max = q.maxSelections || q.options.length;
      const current = Array.isArray(state.answers[key]) ? state.answers[key].slice() : [];
      const idx = current.indexOf(optionId);
      if (idx !== -1) {
        current.splice(idx, 1);
      } else {
        if (current.length >= max) current.shift(); // FIFO when over the cap
        current.push(optionId);
      }
      state.answers[key] = current;
      renderQuestion(); // refresh option states + CTA disabled flag
    } else {
      state.answers[key] = optionId;
      advanceQuestion();
    }
  }

  function advanceQuestion() {
    const keys = getActiveKeys();
    if (state.questionIndex < keys.length - 1) {
      state.questionIndex += 1;
      render();
    } else {
      const result = computeProfileWithScores();
      state.profile = result.profile;
      state.scores  = result.scores;
      state.screen  = "result";

      track("quiz_completed", {
        completed_at: new Date().toISOString(),
        version: state.version,
        gender: state.gender,
        privacy_consent: state.privacy === true,
        answers: state.answers,
        scores: state.scores,
        profile: state.profile.slug
      });

      render();
    }
  }

  /* ---------- Scoring ---------- */

  function computeProfileWithScores() {
    const scores = { curiosoPrudente: 0, esploratore: 0, narratore: 0, degustatore: 0 };

    const keys = getActiveKeys();
    keys.forEach(function (key) {
      const ans = state.answers[key];
      const mapForQ = SCORING[key];
      if (!ans || !mapForQ) return;
      const ids = Array.isArray(ans) ? ans : [ans];
      ids.forEach(function (id) {
        const delta = mapForQ[id];
        if (!delta) return;
        for (const profileKey in delta) scores[profileKey] += delta[profileKey];
      });
    });

    let topScore = -Infinity;
    PROFILES_KEYS.forEach(function (k) { if (scores[k] > topScore) topScore = scores[k]; });
    const tied = PROFILES_KEYS.filter(function (k) { return scores[k] === topScore; });

    let winner;
    if (tied.length === 1) {
      winner = tied[0];
    } else {
      const q14 = state.answers.q14;
      const priority = (q14 && Q14_TIE_PRIORITY[q14]) || TIE_BREAK_FALLBACK;
      winner = priority.find(function (k) { return tied.indexOf(k) !== -1; }) || tied[0];
    }

    return { profile: PROFILES[winner], scores: scores };
  }

  // legacy alias retained for the debug surface (window.__bt.computeProfile)
  function computeProfile() { return computeProfileWithScores().profile; }

  /* ---------- Result + email ---------- */

  function renderResult() {
    setProgress(1);
    clearStage();
    const p = state.profile;

    const screen = el("div", { class: "bt-screen" }, [
      el("span", { class: "bt-result__crest" }, "Il tuo profilo"),
      el("h2", { class: "bt-result__profile" }, "Sei " + p.name + "."),
      el("p", { class: "bt-result__tag" }, p.tagline),

      (function () {
        const s = el("div", { class: "bt-result__section" });
        s.appendChild(el("h3", null, "Perché BlindTaste è per te"));
        s.appendChild(el("p", null, p.promise));
        return s;
      })(),

      (function () {
        const s = el("div", { class: "bt-result__section" });
        s.appendChild(el("h3", null, "Cosa trovi nella tua box"));
        const ul = el("ul", { class: "bt-bullets" });
        p.includes.forEach(function (line) { ul.appendChild(el("li", null, line)); });
        s.appendChild(ul);
        return s;
      })(),

      el("button", {
        class: "bt-cta", type: "button",
        onClick: function () { state.screen = "email"; render(); }
      }, "Iscriviti alla newsletter e ricevi lo sconto del 10%"),

      el("button", {
        class: "bt-link-btn", type: "button",
        onClick: function () { goToLanding(p, null, "result-skip"); }
      }, "Vai direttamente alla box →")
    ]);

    stage.appendChild(screen);
  }

  function renderEmail() {
    setProgress(1);
    clearStage();
    const p = state.profile;

    const errorNode = el("p", { class: "bt-field-error", id: "bt-email-error" }, "");

    const form = el("form", {
      class: "bt-screen",
      onSubmit: function (e) {
        e.preventDefault();
        const emailInput = form.querySelector("input[type=email]");
        const consent = form.querySelector("input[type=checkbox]");
        errorNode.textContent = "";

        const value = (emailInput.value || "").trim();
        if (!value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          errorNode.textContent = "Inserisci un indirizzo email valido.";
          emailInput.focus();
          return;
        }
        if (!consent.checked) {
          errorNode.textContent = "Devi accettare l'iscrizione per ricevere lo sconto.";
          return;
        }

        state.email = value;
        track("email_submitted", {
          email_submitted_at: new Date().toISOString(),
          email: value,
          email_consent: true
        });
        state.screen = "email-thanks";
        render();
      }
    });

    form.appendChild(backButton(function () { state.screen = "result"; render(); }));
    form.appendChild(el("p", { class: "bt-screen__eyebrow" }, "Newsletter"));
    form.appendChild(el("h2", { class: "bt-screen__title" }, "Iscriviti e ottieni lo sconto."));
    form.appendChild(el("p", { class: "bt-screen__sub" },
      "Iscriviti alla newsletter di BlindTaste e ricevi subito uno sconto del 10% sulla tua prima box. Niente spam: solo storie di vino artigianale italiano."
    ));

    const field = el("div", { class: "bt-field" }, [
      el("label", { for: "bt-email" }, "Email"),
      el("input", { type: "email", id: "bt-email", name: "email", autocomplete: "email", required: "required", placeholder: "tu@email.com" })
    ]);
    form.appendChild(field);

    form.appendChild(el("label", { class: "bt-checkbox" }, [
      el("input", { type: "checkbox", name: "consent" }),
      el("span", { html:
        'Iscrivimi alla newsletter di BlindTaste per ricevere il codice sconto e comunicazioni future. ' +
        'Vedi <a href="https://www.theblindtaste.it/pages/informativa-sulla-privacy" target="_blank" rel="noopener">privacy</a>.'
      })
    ]));

    form.appendChild(errorNode);
    form.appendChild(el("button", { class: "bt-cta", type: "submit" }, "Iscriviti e ricevi lo sconto del 10%"));
    form.appendChild(el("button", {
      class: "bt-link-btn", type: "button",
      onClick: function () { goToLanding(p, null, "email-skip"); }
    }, "No grazie, continua alla box"));

    stage.appendChild(form);
  }

  function renderEmailThanks() {
    setProgress(1);
    clearStage();
    const p = state.profile;
    const screen = el("div", { class: "bt-screen" }, [
      el("span", { class: "bt-result__crest" }, "Iscrizione confermata"),
      el("h2", { class: "bt-result__profile" }, "Grazie."),
      el("p", { class: "bt-result__tag" }, "Sei iscritto alla newsletter. Controlla la tua mail: ti abbiamo appena mandato il codice sconto del 10%."),
      el("button", {
        class: "bt-cta", type: "button",
        onClick: function () { goToLanding(p, state.email, "email-thanks"); }
      }, "Scopri la tua box"),
      el("a", { class: "bt-link-btn", href: "/" }, "Torna al sito")
    ]);
    stage.appendChild(screen);
  }

  /* ---------- Landing redirect ---------- */

  function buildLandingUrl(profile, email) {
    const params = new URLSearchParams();
    params.set("profile", profile.slug);
    params.set("source", "quiz");
    if (state.sessionId) params.set("session_id", state.sessionId);
    if (email) params.set("email", btoa(email));
    // Shopify destination: theblindtaste.it/pages/blindbox
    // For local prototype testing, temporarily change to "landing.html?".
    return "/pages/blindbox?" + params.toString();
  }

  function goToLanding(profile, email, exitPoint) {
    track("landing_redirect", {
      landing_visited_at: new Date().toISOString(),
      landing_with_email: Boolean(email),
      exit_point: exitPoint   // "result-skip" | "email-skip" | "email-thanks"
    });
    window.location.href = buildLandingUrl(profile, email);
  }

  /* ---------- Router ---------- */

  function render() {
    switch (state.screen) {
      case "intro":             return renderIntro();
      case "version":           return renderVersion();
      case "gender":            return renderGender();
      case "privacy":           return renderPrivacy();
      case "privacy-declined":  return renderPrivacyDeclined();
      case "question":          return renderQuestion();
      case "result":            return renderResult();
      case "email":             return renderEmail();
      case "email-thanks":      return renderEmailThanks();
      default:                  return renderIntro();
    }
  }

  // expose for debugging
  window.__bt = { state, QUESTIONS, SCORING, PROFILES, computeProfile };

  render();
})();
